enum TipoCliente {
    Normal = 1,
    Franquia = 2,
    Filial = 3,
    PropriaEmpresa = 4,
}

export default TipoCliente;
